<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-dialog
    v-model="showReportDialog"
    max-width="1000"
  >
    <v-card
      id="report"
      class="px-4 py-8"
      color="white"
      style="border-radius: 12px !important;"
    >
      <div class="px-8">
        <div
          class="text-h1 font-weight-black"
          style="font-size: 98px !important;"
        >
          {{ date }} {{ $t('BusinessReport') }}
        </div>
        <div class="d-flex align-center text-h3 mt-8">
          <div style="font-size: 36px !important;">
            {{ $t('BusinessReportGrowStatus') }}
          </div>
          <v-spacer />

          <div style="width: 300px">
            <div class="text-body-2">
              {{ $t('BusinessReportDisclaimer') }}
            </div>
            <template v-if="!downloadLoading">
              <div
                class="text-body-2 mt-4 text-decoration-underline"
                @click="download"
              >
                {{ $t('BusinessReportPDFDownload') }}
                <v-icon
                  color="black"
                  small
                >
                  mdi-arrow-bottom-right
                </v-icon>
              </div>
            </template>
            <template v-else>
              <div class="d-flex align-center mt-2">
                <v-progress-circular
                  indeterminate
                  size="24"
                />
                <span class="text-h4 ml-4">{{ $t('BusinessReportDownloadStatus') }}...</span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="mt-8">
        <v-card
          color="amber lighten-3"
          elevation="0"
          tile
        >
          <div style="display: grid;grid-gap: 36px;grid-template-columns: 340px minmax(0,1fr)">
            <div class="pa-8">
              <div class="text-body-2 font-weight-bold">
                {{ $t('BusinessReportMainlyData') }}
              </div>
              <div class="mt-16">
                <template v-for="(data,index) in realMainData">
                  <div :key="data.label+'d'">
                    <div class="d-flex">
                      <div class="text-h1 text-no-wrap font-weight-bold">
                        <template v-if="data?.type==='percent'">
                          {{ data.value | percent }}
                        </template>
                        <template v-else>
                          {{ data.value | reportPriceDisplay }}
                        </template>
                      </div>
                      <v-spacer />
                      <div class="text-caption mt-4 font-weight-bold">
                        {{ (data.percent) | percent }}
                        <v-icon
                          v-if="data.value > 0"
                          color="black"
                          small
                        >
                          mdi-arrow-top-right
                        </v-icon>
                        <v-icon
                          v-else
                          color="black"
                          small
                        >
                          mdi-arrow-bottom-right
                        </v-icon>
                      </div>
                    </div>
                    <div class="text-body-1 ml-1 mt-2 text--secondary">
                      {{ data.label }}
                    </div>
                  </div>
                  <v-divider
                    v-if="index!==realMainData.length-1"
                    :key="data.label+'f'"
                    class="my-8 grey lighten-1"
                  />
                </template>
              </div>
            </div>
            <div>
              <v-img
                :src="require('@/assets/background/2.jpg')"
                height="100%"
              />
            </div>
          </div>
        </v-card>
        <!--        <div class="px-8  mt-16 ">-->
        <!--          <div class="text-h2 font-weight-black">-->
        <!--            {{ $t('BusinessReportShopHighlights') }}-->
        <!--          </div>-->
        <!--          <div-->
        <!--            class="mt-8"-->
        <!--            style="display: grid;grid-template-columns: repeat(4,minmax(0,1fr));"-->
        <!--          >-->
        <!--            <div-->
        <!--              v-for="i in 7"-->
        <!--              :key="i"-->
        <!--              class="d-flex flex-column mb-6 mr-6 pr-6"-->
        <!--              style="border-right: 2px solid lightgrey;height: 144px"-->
        <!--            >-->
        <!--              <div class="text-body-1 grey&#45;&#45;text font-weight-bold">-->
        <!--                2022.12.12-->
        <!--              </div>-->
        <!--              <div class="text-h4 font-weight-bold mt-1">-->
        <!--                {{ $t('DailySales') }}{{ 19222 | priceDisplay }},{{ $t('MakeHistoryRecord') }}-->
        <!--              </div>-->
        <!--              <v-spacer/>-->
        <!--              <div class="text-caption">-->
        <!--                dwahduwah aw-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <v-card
          class="mt-16"
          color="black"
          elevation="0"
          tile
        >
          <div class="pa-8 py-16">
            <div style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr))">
              <div>
                <div
                  class="text-body-2 font-weight-bold"
                  style="color: white"
                >
                  {{ $t('ThisMonthFixCosts') }}
                </div>
                <div class="d-flex mt-8">
                  <div
                    class="text-h1 font-weight-black "
                    style="font-size: 72px !important; color: white"
                  >
                    {{ totalCost | reportPriceDisplay }}
                  </div>
                  <div
                    class="text-body-2"
                    style="color: white"
                  >
                    {{ $t('EUR') }}
                  </div>
                </div>
              </div>
              <div
                class="text-body-2"
                style="color: white"
              >
                {{ $t('CostsSeparateInTwoElements') }}
                {{ $t('CostsSeparateInTwoElementsText') }}
              </div>
            </div>
            <div
              class="mt-16"
              style="display: grid;grid-template-columns: repeat(4,minmax(0,1fr))"
            >
              <div>
                <div class="text-body-2 font-weight-medium grey--text text--lighten-2">
                  {{ $t('CollectMaterial') }}
                </div>
                <div class="d-flex mt-4">
                  <div
                    class="text-h3 font-weight-black "
                    style="color: white"
                  >
                    {{ purchasingCostTotal | reportPriceDisplay }}
                  </div>
                </div>
              </div>
              <div>
                <div class="text-body-2 font-weight-medium grey--text text--lighten-2">
                  {{ $t('FixCosts') }}
                </div>
                <div class="d-flex mt-4">
                  <div
                    class="text-h3 font-weight-black "
                    style="color: white"
                  >
                    {{ fixedCosts | reportPriceDisplay }}
                  </div>
                </div>
              </div>
              <div>
                <div class="text-body-2 font-weight-medium grey--text text--lighten-2">
                  {{ $t('EmploymentCosts') }}
                </div>
                <div class="d-flex mt-4">
                  <div
                    class="text-h3 font-weight-black "
                    style="color: white"
                  >
                    {{ LaborCosts | reportPriceDisplay }}
                  </div>
                </div>
              </div>
              <div>
                <div
                  class="text-body-2 font-weight-medium grey--text text--lighten-2"
                >
                  {{ $t('MarketingCosts') }}
                </div>
                <div class="d-flex mt-4">
                  <div
                    class="text-h3 font-weight-black "
                    style="color: white"
                  >
                    {{ marketingExpenses | reportPriceDisplay }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-8">
              <apex-chart
                v-if="graphIsReady"
                :options="options"
                :series="series"
                height="300"
                type="bar"
                width="100%"
              />
            </div>
          </div>
        </v-card>
        <div class="px-8  mt-16 ">
          <div class="text-h2 font-weight-black">
            {{ $t('BusinessStatus') }}<br>
            {{ $t('ViewEverything') }}
          </div>

          <div
            class="mt-16"
            style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px;min-height: 500px"
          >
            <div
              class="d-flex flex-column py-8 my-1"
              style="border-top: 1px solid lightgrey;border-bottom: 1px solid lightgrey"
            >
              <div
                class="text-h1 font-weight-black "
                style="font-size: 72px !important;"
              >
                {{ currentNetProfit | reportPriceDisplay }}
              </div>
              <div class="text-h4 ml-2 mt-2 font-weight-bold">
                {{ $t('OperatingPlusThisMonth') }}
              </div>
              <v-spacer />
              <div
                class="text-body-2"
                style="max-width: 65%"
              >
                {{ $t('NetAmountDiagramText') }}
              </div>
            </div>
            <daliy-win-lost-chart
              :daily-info="dailySalesInfo"
              :total-cost="totalCost"
            />
          </div>
          <div
            class="mt-4"
            style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px;min-height: 500px"
          >
            <div class="d-flex flex-column justify-center">
              <div style="display:grid;grid-template-columns: repeat(3,minmax(0,1fr));grid-gap: 4px;height:min-content;">
                <v-card
                  v-for="(i,index) in mostPopularDishInfo"
                  :key="i.index"
                  color="black"
                  dark
                  elevation="0"
                  tile
                >
                  <v-responsive :aspect-ratio="0.9">
                    <div
                      class="d-flex flex-column pa-4"
                      style="height: 100%;"
                    >
                      <div class="d-flex align-baseline primary--text text--lighten-4">
                        <span class="text-caption font-weight-black">No.</span>
                        <div class="text-h4 ">
                          {{ index + 1 }}
                        </div>
                      </div>
                      <v-spacer />
                      <div
                        class="text-body-2 font-weight-black"
                        style="line-clamp:2;display:-webkit-box;-webkit-line-clamp:2;text-overflow: ellipsis;
                          -webkit-box-orient: vertical;overflow:hidden"
                      >
                        {{ i?.name }}
                      </div>
                      <div class="text-caption grey--text text--lighten-2 font-weight-bold mt-1">
                        {{ i?.dishCount }} 个
                      </div>
                    </div>
                  </v-responsive>
                </v-card>
              </div>
            </div>

            <div
              v-if="mostPopularDishInfo"
              class="d-flex flex-column py-8 my-1"
              style="border-top: 1px solid lightgrey;border-bottom: 1px solid lightgrey"
            >
              <div
                class="text-h1 font-weight-black "
                style="font-size: 72px !important;"
              >
                {{ mostPopularDishInfo[0]?.name }}🍗
              </div>
              <div class="text-h4 ml-2 mt-2 font-weight-bold">
                {{ $t('FavoriteSalesThisMonth') }}{{ mostPopularDishInfo[0]?.dishCount }} {{ $t('Pice') }}
              </div>
              <v-spacer />
              <div
                class="text-body-2"
                style="max-width: 65%"
              >
                {{ $t('Exist') }}{{ ((mostPopularDishInfo[0]?.orderCount / orderInfoInMonth?.totalOrderCount) * 100).toFixed(2) }}% {{ $t('FavoriteOrderStatistics') }}{{ mostPopularDishInfo[0]?.name }}🍗，{{ $t('FavoriteOrderStatisticsText') }}
              </div>
            </div>
          </div>

          <div
            v-if="togoInfo"
            class="mt-8"
            style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px;min-height: 500px"
          >
            <div
              class="d-flex flex-column py-8 my-1"
              style="border-top: 1px solid lightgrey;border-bottom: 1px solid lightgrey"
            >
              <div
                class="text-h1 font-weight-black "
                style="font-size: 72px !important;"
              >
                {{ togoInfo.total | reportPriceDisplay }}
              </div>
              <div class="text-h4 ml-2 mt-2 font-weight-bold">
                {{ $t('TotalOrderedOfToGo') }}
              </div>
              <v-spacer />
              <div
                class="text-body-2"
                style="max-width: 65%"
              >
                {{ $t('ShareOfTotalSales') }}{{ togoRatio }}%, {{ $t('ShareOfTotalSalesText') }}
              </div>
            </div>
            <order-type-chart :info="consumeTypeInfo" />
          </div>
          <div
            class="mt-4"
            style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px;min-height: 500px"
          >
            <div
              v-if="memberInfo && businessReportInfo"
              class="d-flex flex-column justify-center"
            >
              <div style="display:grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 4px;height:min-content;">
                <v-card
                  v-for="(p,i) in realMemberInfo"
                  :key="p.label"
                  :color="colors[i]"
                  :dark="i<=2"
                  elevation="0"
                  tile
                >
                  <v-responsive :aspect-ratio="0.9">
                    <div
                      class="d-flex flex-column pa-4"
                      style="height: 100%;"
                    >
                      <div class="text-h3">
                        {{ p.label }}
                      </div>
                      <v-spacer />
                      <div
                        class="text-h2 font-weight-black"
                      >
                        <template v-if="p.type==='string'">
                          {{ p.value }}
                        </template>
                        <template v-else>
                          {{ p.value | reportPriceDisplay }}
                        </template>
                      </div>
                      <div class="text-body-2">
                        {{ p.desc }}
                      </div>
                    </div>
                  </v-responsive>
                </v-card>
              </div>
            </div>
            <div
              v-if="businessReportInfo"
              class="d-flex flex-column py-8 my-1"
              style="border-top: 1px solid lightgrey;border-bottom: 1px solid lightgrey"
            >
              <div
                class="text-h1 font-weight-black "
                style="font-size: 72px !important;"
              >
                {{ orderInfoInMonth?.totalPersonCount }}
              </div>
              <div class="text-h4 ml-2 mt-2 font-weight-bold">
                {{ $t('TotalOfGuests') }}
              </div>
              <v-spacer />
              <div
                class="text-body-2"
                style="max-width: 65%"
              >
                {{ $t('TotalOfGuestsText') }}
              </div>
            </div>
          </div>
          <div
            class="mt-8"
            style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px;min-height: 500px"
          >
            <div
              class="d-flex flex-column py-8 my-1"
              style="border-top: 1px solid lightgrey;border-bottom: 1px solid lightgrey"
            >
              <div
                class="text-h1 font-weight-black "
                style="font-size: 72px !important;"
              >
                {{ avgOccupyLength }}
              </div>
              <div class="text-h4 ml-2 mt-2 font-weight-bold">
                {{ $t('AverageOrderQuantity') }}
              </div>
              <v-spacer />
              <div
                class="text-body-2"
                style="max-width: 65%"
              >
                {{ $t('NumberOrdersDifferentMealTimes') }}
              </div>
            </div>
            <order-time-chart :daily-info="dailyOccupyLengthInfo" />
          </div>
        </div>
        <v-card
          class="mt-16"
          color="blue darken-4"
          dark
          elevation="0"
          tile
        >
          <div class="pa-8 py-16">
            <div style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr))">
              <div>
                <div class="text-body-2 font-weight-bold">
                  {{ $t('TotalNumberOfAppointments') }}
                </div>
                <div class="d-flex mt-8">
                  <div
                    class="text-h1 font-weight-black "
                    style="font-size: 72px !important;"
                  >
                    {{ reservationTotalInfo?.reserveCount | reportPriceDisplay }}
                  </div>
                  <div class="text-body-2">
                    {{ $t('SecondRate') }}
                  </div>
                </div>
              </div>
              <div class="text-body-2">
                {{ $t('FrontEndRecord') }}
              </div>
            </div>
            <div
              class="mt-16"
              style="display: grid;grid-template-columns: repeat(4,minmax(0,1fr))"
            >
              <div>
                <div class="text-body-2 font-weight-medium grey--text text--lighten-2">
                  {{ $t('TotalOfPlannedArrivals') }}
                </div>
                <div class="d-flex mt-4">
                  <div
                    class="text-h3 font-weight-black "
                  >
                    {{ reservationTotalInfo?.arriveCount | reportPriceDisplay }}
                  </div>
                </div>
              </div>
              <div>
                <div class="text-body-2 font-weight-medium grey--text text--lighten-2">
                  {{ $t('BookedArrivalPrice') }}
                </div>
                <div class="d-flex mt-4">
                  <div
                    class="text-h3 font-weight-black "
                  >
                    {{ (reservationTotalInfo?.arriveRatio * 100).toFixed(2) + '%' }}
                  </div>
                </div>
              </div>
              <div>
                <div class="text-body-2 font-weight-medium grey--text text--lighten-2">
                  {{ $t('AverageDailyArrivals') }}
                </div>
                <div class="d-flex mt-4">
                  <div
                    class="text-h3 font-weight-black "
                  >
                    {{ reservationTotalInfo?.avgDailyArrive | reportPriceDisplay }}
                  </div>
                </div>
              </div>
              <div>
                <div class="text-body-2 font-weight-medium grey--text text--lighten-2">
                  {{ $t('TotalOfNewUsersThisMonth') }}
                </div>
                <div class="d-flex mt-4">
                  <div
                    class="text-h3 font-weight-black "
                  >
                    {{ 451|reportPriceDisplay }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-8">
              <reservation-chart :daily-info="reservationDailyInfo" />
            </div>
          </div>
        </v-card>
      </div>
      <div class="px-8 mt-16">
        <div class="text-h2 font-weight-black">
          {{ $t('DailyBusinessStatus') }}
        </div>
        <div class="text-h4">
          {{ $t('BusinessDetailedRecord') }}
        </div>
        <div class="mt-8">
          <every-day-table
            :fixed-total-cost="fixedCostTotal"
            :info="businessReportInfo"
            :total-cost="totalCost"
          />
        </div>
      </div>
      <v-card
        class="mt-16"
        color="grey lighten-4"

        elevation="0"
        tile
      >
        <div class="pa-8 py-16">
          <div style="display:grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px;height:500px">
            <div class="d-flex flex-column">
              <restaurant-logo-display
                :store-img="storeLogo"
                :store-name="storeInfo?.name"
                size="large"
              />

              <v-spacer />
              <div class="mb-4">
                <logo-display

                  size="large"
                />
                <div class="text-body-2 mt-4">
                  {{ $t('SimplifyStoreScientifically') }}
                </div>
              </div>

              <j-space>
                <div class="text-body-2 text-no-wrap text-decoration-underline">
                  {{ $t('AadenPosWebseite') }}
                </div>
                <div class="text-body-2 text-no-wrap text-decoration-underline">
                  {{ $t('ContactUs') }}
                </div>
                <div class="text-body-2 text-no-wrap text-decoration-underline">
                  {{ $t('LicenseAndPrivacy') }}
                </div>
              </j-space>
            </div>

            <div class="d-flex flex-column">
              <div class="text-h1 font-weight-black">
                {{ $t('Thanks') }}
              </div>
              <div class="text-body-1 mt-4">
                {{ $t('AadenPosBusinessSubtext') }}
              </div>
              <v-spacer />
              <div
                class="d-flex align-center"
                @click="download"
              >
                <div class="text-h3 text-decoration-underline">
                  {{ $t('BusinessRecordPDFVersionHint') }}
                </div>
                <v-icon
                  class="ml-2 "
                  color="black"
                  size="36"
                >
                  mdi-arrow-bottom-right-thin-circle-outline
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import DaliyWinLostChart from '@/views/AadenPages/billAndReport/analysis/report/fragment/chart/DaliyWinLostChart.vue'
import OrderTimeChart from '@/views/AadenPages/billAndReport/analysis/report/fragment/chart/OrderTimeChart.vue'
import { random } from 'lodash-es'
import OrderTypeChart from '@/views/AadenPages/billAndReport/analysis/report/fragment/chart/OrderTypeChart.vue'
import ReservationChart from '@/views/AadenPages/billAndReport/analysis/report/fragment/chart/ReservationChart.vue'
import EveryDayTable from '@/views/AadenPages/billAndReport/analysis/report/fragment/chart/EveryDayTable.vue'
import LogoDisplay from '@/views/widget/uiComponent/LogoDisplay.vue'
import JSpace from '@/views/AadenPages/components/JSpace.vue'
import RestaurantLogoDisplay from '@/views/widget/commonLogic/RestaurantLogoDisplay.vue'
import * as htmlToImage from 'html-to-image'
import download from 'downloadjs'
import { loadDashboardData } from '@/model/dataLayer/service/DashboardService'
import dayjs from 'dayjs'
import { getBusinessReportInfo, getTimeByHourMinSec } from '@/model/dataLayer/api/report/report'
import Payment from '@/model/dataLayer/api/common/Payment'
import { take } from 'lodash'
import { getInfoForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { getCurrentStoreId } from '@/model/dataLayer/api/SaaS/user'
import { getFixedCost, getPurchasingCost } from '@/model/dataLayer/api/report/salesReportApi'
import { getRootUrl } from '@/model/global/GlobalSettings'

export default {
  name: 'StoreReportDialog',
  components: { RestaurantLogoDisplay, JSpace, LogoDisplay, EveryDayTable, ReservationChart, OrderTypeChart, OrderTimeChart, DaliyWinLostChart },
  props: {
    purchasingCostTotal: {},
    fixedCostTotal: {},
    totalCost: {},
    date: {},
    value: {
      type: Boolean
    }
  },
  data: function () {
    return {
      downloadLoading: false,
      lastMonthBusinessReportInfo: [],
      currentMonthFixedCost: [],
      lastMonthFixedList: [],
      lastMonthPurchasingList: [],
      lastMonthDashboardInfo: [],
      storeInfo: [],
      businessReportInfo: [],
      paymentMethodList: [],
      dashboardInfo: [],
      showReportDialog: false,
      series: [],
      colors: [
        '#8a8a8a',
        '#3a3a3a',
        '#bababa',
        '#fbdc46'
      ],
      personInfo: [
        { label: this.$t('MembersAverageAge'), value: random(16, 48) + this.$t('Age'), desc: '', type: 'string' },
        { label: this.$t('MemberAmount'), value: random(100, 5000), desc: '', type: 'string' },
        { label: this.$t('TotalMemberBalance'), value: random(0, 9888000).toFixed(2), desc: '', type: 'number' },
        { label: this.$t('CustomersSpending'), value: random(0, 200.5).toFixed(2), desc: '', type: 'number' }
      ],
      options: {},
      graphIsReady: false,
      mainData: [
        {
          label: this.$t('ThisMonthSales'),
          value: 0,
          percent: 0
        },
        {
          label: this.$t('TotalCostsThisMonth'),
          value: 0,
          percent: 0
        },
        {
          label: this.$t('NetProfitThisMonth'),
          value: 0,
          percent: 0
        },
        {
          label: this.$t('AverageDailyFluctuationThisMonth'),
          value: 0,
          percent: 0,
          type: 'percent'
        }
      ]
    }
  },
  computed: {
    storeLogo () {
      return getRootUrl() + this.storeInfo.buffetLogo
    },
    LaborCosts () {
      return this.currentMonthFixedCost.filter(it => it.label === '用人成本（固定开支）' || it.label === '用人成本（弹性开支）').map(x => parseFloat(x.value)).reduce((a, b) => a + b, 0)
    },
    marketingExpenses () {
      return this.currentMonthFixedCost.filter(it => it.label === '营销成本').map(x => parseFloat(x.value)).reduce((a, b) => a + b, 0)
    },
    fixedCosts () {
      return this.currentMonthFixedCost.filter(it => it.label === '房租（按月）' || it.label === '房租（按月）' || it.label === '水电气费用' || it.label === '设备折旧' || it.label === '低值易耗品').map(x => parseFloat(x.value)).reduce((a, b) => a + b, 0)
    },
    dailySalesInfo () {
      return this.businessReportInfo.dailyBusinessInfo
    },
    togoRatio () {
      return (this.togoInfo.total / this.currentTotalSales * 100).toFixed(2)
    },
    togoInfo () {
      return this.consumeTypeInfo.find(it => it.consumeTypeId === '2')
    },
    consumeTypeInfo () {
      return this.dashboardInfo?.salesInfo?.consumeTypeInfo ?? []
    },
    dailyOccupyLengthInfo () {
      return this.businessReportInfo.occupyLengthInfo
    },
    avgOccupyLength () {
      return getTimeByHourMinSec(this.businessReportInfo.avgOccupyLength)
    },
    memberInfo () {
      return this.businessReportInfo.memberInfo
    },
    mostPopularDishInfo () {
      return take(this.businessReportInfo?.mostPopularDishInMonth, 9)
    },
    reservationDailyInfo () {
      return this.businessReportInfo.reservationInfo
    },
    reservationTotalInfo () {
      return this.businessReportInfo.reservationTotalInfo
    },
    orderInfoInMonth () {
      return this.businessReportInfo.orderInfoInMonth
    },
    avgMemberConsumption () {
      if (this.orderInfoInMonth?.totalPersonCount > 0) {
        return (this.orderInfoInMonth?.totalTotalPrice / this.orderInfoInMonth?.totalPersonCount).toFixed(2)
      } else {
        return this.$t('CustomersHasntSpentAnyMoney')
      }
    },
    realMemberInfo () {
      return [
        { label: this.$t('AverageAgeOfMembers'), value: this.memberInfo.avgAge ?? 24 + this.$t('Age'), desc: '', type: 'number' },
        { label: this.$t('MemberAmount'), value: this.memberInfo.totalMemberCount ?? 0, desc: '', type: 'number' },
        { label: this.$t('TotalMemberBalance'), value: this.memberInfo.totalCurrentAmount ?? 0, desc: '', type: 'number' },
        { label: this.$t('CustomersSpending'), value: this.avgMemberConsumption, desc: '', type: 'number' }
      ]
    },
    realMainData () {
      return [
        {
          label: this.$t('ThisMonthSales'),
          value: this.currentTotalSales ?? 0,
          percent: (this.currentTotalSales - this.lastMonthTotalSales) / this.lastMonthTotalSales
        },
        {
          label: this.$t('TotalCostsThisMonth'),
          value: this.totalCost ?? 0,
          percent: this.lastMonthTotalCost === 0 ? 0 : (this.totalCost - this.lastMonthTotalCost) / this.lastMonthTotalCost
        },
        {
          label: this.$t('NetProfitThisMonth'),
          value: this.currentNetProfit ?? 0,
          percent: (this.currentNetProfit - (this.lastMonthTotalSales - this.lastMonthTotalCost)) / (this.lastMonthTotalSales - this.lastMonthTotalCost)
        },
        {
          label: this.$t('AverageDailyFluctuationThisMonth'),
          value: this.businessReportInfo.avgTurnoverRate,
          percent: this.lastMonthBusinessReportInfo.avgTurnoverRate === 0 ? 0 : ((this.businessReportInfo.avgTurnoverRate - this.lastMonthBusinessReportInfo.avgTurnoverRate) / this.lastMonthBusinessReportInfo.avgTurnoverRate),
          type: 'percent'
        }
      ]
    },
    currentNetProfit () {
      return parseFloat(this.currentTotalSales - this.totalCost).toFixed(2)
    },
    lastMonthTotalCost () {
      const purchasingTotal = this.lastMonthPurchasingList.length > 0 ? this.lastMonthPurchasingList.map(it => it.value).reduce((a, b) => a + b, 0) : 0
      const fixedTotal = this.lastMonthFixedList.length > 0 ? this.lastMonthFixedList.map(it => it.value).reduce((a, b) => a + b, 0) : 0
      return purchasingTotal + fixedTotal
    },
    lastMonthTotalSales () {
      return parseFloat(this.lastMonthDashboardInfo?.taxInfos?.content?.total).toFixed(2) ?? 0
    },
    currentTotalSales () {
      return parseFloat(this.dashboardInfo?.taxInfos?.content?.total).toFixed(2) ?? 0
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.showReportDialog = true
        this.reload()
      }
    },
    showReportDialog (val) {
      if (!val) {
        this.$emit('input', false)
      }
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    async reload () {
      this.dashboardInfo = (await loadDashboardData([dayjs(this.date).startOf('month').format('YYYY-MM-DD'), dayjs(this.date).endOf('month').format('YYYY-MM-DD')]))
      this.lastMonthDashboardInfo = (await loadDashboardData([dayjs(this.date).subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), dayjs(this.date).subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]))
      this.paymentMethodList = await Payment.getList()
      this.lastMonthPurchasingList = await getPurchasingCost(dayjs(this.date).subtract(1, 'month').format('YYYY-MM')) ?? []
      this.lastMonthFixedList = await getFixedCost(dayjs(this.date).subtract(1, 'month').format('YYYY-MM')) ?? []
      const fromTime = dayjs(this.date).startOf('month').add(4, 'hour').format('YYYY-MM-DD HH:mm:ss')
      const toTime = dayjs(this.date).endOf('month').add(4, 'hour').format('YYYY-MM-DD HH:mm:ss')
      const timespan = [fromTime, toTime]
      const lastMonthFromTime = dayjs(this.date).startOf('month').subtract(1, 'month').add(4, 'hour').format('YYYY-MM-DD HH:mm:ss')
      const lastMonthToTime = dayjs(this.date).endOf('month').subtract(1, 'month').add(4, 'hour').format('YYYY-MM-DD HH:mm:ss')
      const lastMontTimespan = [lastMonthFromTime, lastMonthToTime]
      this.businessReportInfo = (await getBusinessReportInfo(timespan))
      this.currentMonthFixedCost = await getFixedCost((dayjs(this.date).format('YYYY-MM')))
      this.lastMonthBusinessReportInfo = (await getBusinessReportInfo(lastMontTimespan))
      this.storeInfo = await getInfoForDeviceId(await getCurrentStoreId())
      await this.initGraph()
    },
    initGraph: async function () {
      this.graphIsReady = false
      this.series = [
        {
          data: [this.purchasingCostTotal, this.fixedCosts, this.LaborCosts, this.marketingExpenses]
        }
      ]

      this.options = {
        fill: {
          colors: [
            '#8a8a8a',
            '#3a3a3a',
            '#bababa',
            '#fbdc46'
          ]
        },
        plotOptions: {
          bar: {
            columnWidth: '100%',
            distributed: true
          }
        },
        yaxis: {
          show: false
        },
        chart: {
          height: 200,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        grid: {
          show: false
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true
        },
        xaxis: {
          categories: [this.$t('CollectMaterial'), this.$t('FixCosts'), this.$t('EmploymentCosts'), this.$t('MarketingCosts')],
          labels: {
            style: {
              colors: ['#fff', '#fff', '#fff', '#fff']
            },
            offsetX: -28,
            offsetY: -4
          },
          axisTicks: {
            show: false
          }
        }
      }
      this.graphIsReady = true
    },
    async download () {
      this.downloadLoading = true
      const node = document.getElementById('report')
      const data = await htmlToImage.toPng(node)
      download(data, 'report.png')
      this.downloadLoading = false
    }
  }
}
</script>

<style scoped>

</style>
